import { getEngines } from "metabase/databases/selectors";
import { isDeprecatedEngine } from "metabase/databases/utils/engine";
import type { State } from "metabase/redux/store";
import type Database from "metabase-lib/v1/metadata/Database";

interface Props {
  databases?: Database[];
}

export const hasDeprecatedDatabase = (state: State, props: Props): boolean => {
  const engines = getEngines(state);
  return (
    props.databases?.some(
      (d) => !d.is_sample && d.engine && isDeprecatedEngine(engines, d.engine),
    ) ?? false
  );
};

export const getAdminPaths = (state: State) => {
  return state.admin?.app?.paths ?? [];
};

export const isDeprecationNoticeEnabled = (state: State): boolean => {
  // check if the deprecation notice has been dismissed on this version
  return (
    state.settings?.values?.version?.tag !==
    state.settings?.values?.["deprecation-notice-version"]
  );
};

export const getCurrentVersion = (state: State) =>
  state.settings?.values.version?.tag ?? "";
